// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris


export function wireOptional<T>(value: T | null | undefined): T | undefined {
  return value === null || value === undefined ? undefined : value;
}

export function wireList<T>(value: readonly T[] | null | undefined): T[] {
  return value === null || value === undefined ? [] : [...value];
}

export function stripWireNulls<T>(value: T): T {
  if (Array.isArray(value)) {
    return value.map((entry) =>
      entry === null ? entry : stripWireNulls(entry),
    ) as unknown as T;
  }

  if (isPlainObject(value)) {
    const out: Record<string, unknown> = {};
    for (const [key, entry] of Object.entries(value)) {
      if (entry === null) {
        continue;
      }
      out[key] = stripWireNulls(entry);
    }
    return out as T;
  }

  return (value === null ? undefined : value) as T;
}

function isPlainObject(value: unknown): value is Record<string, unknown> {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const proto = Object.getPrototypeOf(value) as unknown;
  return proto === Object.prototype || proto === null;
}